import { ref } from "vue";

export function useEditableArray(stringArray) {
    const items = ref(stringArray.map(text => ({ id: generateId(), text })));

    function generateId() {
        return Math.random().toString(36).substr(2, 9);
    }

    function getStringArray() {
        return items.value.map(item => item.text);
    }

    return { items, getStringArray };
}
